import React from "react"
import {
  Text as ChakraText,
  TextProps as ChakraTextProps,
} from "@chakra-ui/react"
import { motion, HTMLMotionProps } from "framer-motion"

export type TextType = "introduction" | "medium" | "small" | "caption" | "legal"

type FramerMotionProps = HTMLMotionProps<"p">

type CustomTextProps = {
  /**
   * defines the styles to be displayed
   */
  type: TextType
}

export type TextProps = CustomTextProps & ChakraTextProps & FramerMotionProps

const ChakraTextWithMotion = motion(ChakraText)

export const Text: React.FC<TextProps> = ({
  children,
  type,
  color,
  ...props
}) => {
  switch (type) {
    case "introduction":
      return (
        <ChakraTextWithMotion
          lineHeight="introduction"
          fontSize="introduction"
          fontWeight="400"
          color={color}
          {...props}
        >
          {children}
        </ChakraTextWithMotion>
      )
    case "medium":
      return (
        <ChakraTextWithMotion
          lineHeight="body"
          fontSize="body.medium"
          color={color}
          {...props}
        >
          {children}
        </ChakraTextWithMotion>
      )
    case "small":
      return (
        <ChakraTextWithMotion
          lineHeight="body"
          fontSize="body.small"
          color={color}
          {...props}
        >
          {children}
        </ChakraTextWithMotion>
      )
    case "caption":
      return (
        <ChakraTextWithMotion
          lineHeight="caption"
          fontSize="caption"
          textTransform="uppercase"
          color={color}
          {...props}
        >
          {children}
        </ChakraTextWithMotion>
      )
    case "legal":
      return (
        <ChakraTextWithMotion
          lineHeight="legal"
          fontSize="legal"
          color={color}
          {...props}
        >
          {children}
        </ChakraTextWithMotion>
      )
    default:
      return <ChakraTextWithMotion {...props}>{children}</ChakraTextWithMotion>
  }
}
